import { cn } from '@Pages/pageRuntime/lib/utils';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';

const Separator = ({
  className,
  orientation = 'horizontal',
  decorative = true,
  ref,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      'bg-border',
      orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
      className
    )}
    {...props}
  />
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

const LabeledSeparator = ({ label }: { label: string }) => (
  <div className="flex items-center gap-2">
    <Separator orientation="horizontal" />
    <span className="text-muted-foreground">{label}</span>
    <Separator orientation="horizontal" />
  </div>
);
LabeledSeparator.displayName = 'LabeledSeparator';

export { LabeledSeparator, Separator };
